import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import {
    ICreatePromotionPayload,
    IListPromotionsParams,
    IPromotion,
    IPromotionsSettings,
    IUpdatePromotionPayload,
    IUpsertPromotionResponse,
} from "./types"

export const listPromotions = (params: IListPromotionsParams): Promise<AxiosResponse<IPromotion[]>> => {
    return apiInstance.handler.get<IPromotion[]>("/promotions", { params })
}

export const createPromotion = (data: ICreatePromotionPayload): Promise<AxiosResponse<IUpsertPromotionResponse>> => {
    const formData = new FormData()
    formData.append("title", data.title)
    formData.append("description", data.description)
    if (data.begin_at) {
        formData.append("begin_at", data.begin_at)
    }
    if (data.end_at) {
        formData.append("end_at", data.end_at)
    }
    formData.append("image", data.image)

    return apiInstance.handler.post<IUpsertPromotionResponse>("/promotions", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
}

export const updatePromotion = (
    id: string,
    data: IUpdatePromotionPayload
): Promise<AxiosResponse<IUpsertPromotionResponse>> => {
    const formData = new FormData()

    if (typeof data.title !== "undefined") {
        formData.append("title", data.title)
    }
    if (typeof data.description !== "undefined") {
        formData.append("description", data.description)
    }
    if (typeof data.begin_at !== "undefined") {
        formData.append("begin_at", data.begin_at)
    }
    if (typeof data.end_at !== "undefined") {
        formData.append("end_at", data.end_at)
    }
    if (typeof data.image !== "undefined") {
        formData.append("image", data.image)
    }

    return apiInstance.handler.put<IUpsertPromotionResponse>(`/promotions/${id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
}

export const deletePromotion = (id: string): Promise<AxiosResponse<void>> => {
    return apiInstance.handler.delete<void>(`/promotions/${id}`)
}
